import { ProductImages } from './product_images_model';
import { allowedImageUploads, getExtensionFromFilename, isJPEG2000File } from './utils';

/**
 * ProductImageSlideView - provides the look-and-feel for managing images in a product image, lightbox slide view
 */
export class ProductImageSlideView implements MerchantosProductImageSlideView {
  private baseTemplate: string;

  private photoTemplate: string;

  private showImageId: string;

  private options: { type: string; imageType: string; readonly: boolean };

  public $slideView!: JQuery<HTMLElement>;

  // @ts-expect-error ts-migrate(6133) FIXME: 'productId' is declared but its value is never rea... Remove this comment to see the full error message
  private productId: string;

  private productImages: ProductImages;

  constructor(
    productId: string,
    productImages: ProductImages,
    imageId: string,
    options: Partial<ProductImageSlideView['options']>
  ) {
    this.baseTemplate =
      '<div class="product-image-lightbox">' +
      '<div class="product-image-slideshow">' +
      '<ul class="product-slideshow-menu">' +
      '<li class="product-slideshow-menu-item"><a class="close" href="#">' +
      '<i class="icon-remove"></i> Close</a><a class="grid-view" href="#">' +
      '<i class="icon-th"></i> Grid</a></li>' +
      '<li class="product-slideshow-edit-item"><a class="featured" href="#">' +
      '<i class="icon-star"></i> Featured</a>';

    if (!options.readonly) {
      this.baseTemplate +=
        '<a class="mark-featured" href="#">' +
        '<i class="icon-star-empty"></i> Mark as Featured</a>' +
        '<a class="delete">Delete Image</a>';
    }

    this.baseTemplate +=
      '</li></ul><div class="product-slideshow-controls">' +
      '<div class="product-slideshow-control prev"><a href="#">' +
      '<i class="icon-chevron-left"></i></a></div>' +
      '<div class="product-slideshow-control next"><a href="#">' +
      '<i class="icon-chevron-right"></i></a></div></div>' +
      '<ol class="product-slideshow-photos"></ol></div></div>';
    this.photoTemplate =
      '<li class="product-slideshow-photo">' +
      '<img class="proudct-slideshow-phot-reference">' +
      '<div class="product-slideshow-description"></div></li>';
    this.showImageId = imageId;
    this.options = {
      type: 'Item',
      imageType: 'Image',
      readonly: false,
      ...options,
    };

    this.productId = productId;
    this.productImages = productImages;

    this.init();
  }

  init: MerchantosProductImageSlideView['init'] = () => {
    this.render();
    this.initEventHandlers();
  };

  render: MerchantosProductImageSlideView['render'] = () => {
    // add the lockscroll class to prevent scrolling with grid view overlay
    const $body = $('body').addClass('lockscroll');

    // add the slide view overlay
    const $lightboxView = $('div.product-image-lightbox');
    if ($lightboxView.length) {
      $lightboxView.remove();
    }
    this.$slideView = $(this.baseTemplate).prependTo($body);
    const $photos = this.$slideView.find('.product-slideshow-photos');

    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    const imageIdToShow = this.showImageId ? this.showImageId : this.productImages.images.head.id;
    let currentImage = this.productImages.images.head;
    while (currentImage !== null) {
      const $photo = $(this.photoTemplate).appendTo($photos);

      const $img = $photo.find('img');

      const fileName = currentImage.filename;
      const originalExtension = getExtensionFromFilename(fileName);
      const fallbackExtension = allowedImageUploads.WEBP.extension[0].replace('.', '');

      $img.attr(
        'src',
        currentImage.getResizedUrl({
          format: isJPEG2000File({ filename: fileName })
            ? fallbackExtension
            : originalExtension ?? fallbackExtension,
          crop: 'fill',
        })
      );

      if (currentImage.id == imageIdToShow) {
        $photo.addClass('product-slideshow-photo-show');
        $photo.show();
      } else {
        $photo.hide();
      }
      $photo.attr('imageid', currentImage.id);

      if ($photo.hasClass('product-slideshow-photo-show')) {
        this.updateFeaturedImageControl($photo);
      }

      currentImage = currentImage.next;
    }

    if (this.options.readonly) {
      $('.product-slideshow-edit-item').remove();
    }
  };

  initEventHandlers: MerchantosProductImageSlideView['initEventHandlers'] = () => {
    $(document).one('keyup.slideview', (event) => {
      if (event.keyCode === 27) {
        this.$slideView.find('.product-slideshow-menu-item .close').trigger('click');
        $(document).off('keyup.slideview');
      }
    });

    this.$slideView.find('li.product-slideshow-menu-item > a.close').on('click', () => {
      this.closeView();
    });

    this.$slideView.find('li.product-slideshow-menu-item > a.grid-view').on('click', () => {
      $('body').removeClass('lockscroll');
      this.$slideView.trigger('gridselected');
      $(document).off('keyup.slideview');
    });

    this.$slideView.find('.product-slideshow-control.prev').on('click', () => {
      this.showPrevImage();
    });

    this.$slideView.find('.product-slideshow-control.next').on('click', () => {
      this.showNextImage();
    });

    this.$slideView.find('.product-slideshow-edit-item > a.mark-featured').on('click', () => {
      this.setFeaturedImage();
    });

    this.$slideView.find('.product-slideshow-edit-item > a.delete').on('click', () => {
      this.deleteCurrentImage();
    });
  };

  closeView: MerchantosProductImageSlideView['closeView'] = () => {
    $('body').removeClass('lockscroll');
    this.$slideView.trigger('closed');
    this.$slideView.remove();
    $(document).off('keyup.slideview');
  };

  showNextImage: MerchantosProductImageSlideView['showNextImage'] = () => {
    const $currentImage = this.$slideView.find('.product-slideshow-photo-show');
    if ($currentImage) {
      $currentImage.removeClass('product-slideshow-photo-show');
      $currentImage.hide();
      let $nextImage = $currentImage.next();
      if (!$nextImage.length) {
        $nextImage = this.$slideView.find('.product-slideshow-photo').first();
      }
      $nextImage.addClass('product-slideshow-photo-show');
      $nextImage.fadeIn();

      this.updateFeaturedImageControl($nextImage);
    }
  };

  showPrevImage: MerchantosProductImageSlideView['showPrevImage'] = () => {
    const $currentImage = this.$slideView.find('.product-slideshow-photo-show');
    if ($currentImage) {
      $currentImage.removeClass('product-slideshow-photo-show');
      $currentImage.hide();
      let $previousImage = $currentImage.prev();
      if (!$previousImage.length) {
        $previousImage = this.$slideView.find('.product-slideshow-photo').last();
      }
      $previousImage.addClass('product-slideshow-photo-show');
      $previousImage.fadeIn();

      this.updateFeaturedImageControl($previousImage);
    }
  };

  deleteCurrentImage: MerchantosProductImageSlideView['deleteCurrentImage'] = () => {
    // eslint-disable-next-line no-alert
    const response = confirm(
      'Are you sure you want to delete this image?\nThis action cannot be reversed.'
    );
    if (response === true) {
      const $currentImage = this.$slideView.find('.product-slideshow-photo-show');

      if ($currentImage.length) {
        const imageId = $currentImage.attr('imageid');

        $.ajax({
          url: `/API/Account/${window.merchantos.account.id}/${this.options.imageType}/${imageId}`,
          type: 'DELETE',
        }).done(() => {
          this.productImages.removeProductImage(imageId!);
          $currentImage.remove();
          if (this.productImages.images.listSize > 0) {
            this.showNextImage();
          } else {
            this.closeView();
          }
        });
      }
    }
  };

  updateFeaturedImageControl: MerchantosProductImageSlideView['updateFeaturedImageControl'] = (
    $currentImage
  ) => {
    if ($currentImage.length) {
      const $markImgCtrl = this.$slideView.find('.product-slideshow-edit-item > a.mark-featured');
      const $featuredImgCtrl = this.$slideView.find('.product-slideshow-edit-item > a.featured');

      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      if ($currentImage.attr('imageid') == this.productImages.images.head.id) {
        $markImgCtrl.hide();
        $featuredImgCtrl.fadeIn();
      } else {
        $markImgCtrl.fadeIn();
        $featuredImgCtrl.hide();
      }
    }
  };

  setFeaturedImage: MerchantosProductImageSlideView['setFeaturedImage'] = () => {
    const $currentImage = this.$slideView.find('.product-slideshow-photo-show');
    if ($currentImage.length) {
      const currentImage = this.productImages.imageDict[$currentImage.attr('imageid')!];

      if (currentImage !== this.productImages.images.head) {
        const $destination = this.$slideView.find('ol.product-slideshow-photos > li').first();
        const destinationImage = this.productImages.imageDict[$destination.attr('imageid')!];

        $currentImage.insertBefore($destination);
        this.productImages.images.insertBefore(currentImage, destinationImage);

        this.updateFeaturedImageControl($currentImage);
      }
    }
  };
}
